import { css } from '@emotion/core';
import { rgba, variables } from '@domain-group/fe-brary';
import { typography } from '@domain-group/fe-co-allhomes-design-system';
var colour = variables.colour;
export var container = /*#__PURE__*/css("display:flex;flex-direction:row;align-items:center;background:", colour.white, ";box-shadow:0px -4px 12px ", rgba(30, 41, 61, 0.15), ";outline:none;text-decoration:none;color:unset;");
export var image = {
  name: "tgvl1u",
  styles: "display:flex;flex-direction:row;justify-content:center;align-items:center;padding:9px 16px 9px 8px;height:70px;"
};
export var content = {
  name: "10jvtv9",
  styles: "margin:4px 0;min-width:220px;"
};
export var heading = /*#__PURE__*/css(typography.bodyBold);
export var text = /*#__PURE__*/css(typography.body);
export var chevron = {
  name: "1kecrfn",
  styles: "display:flex;align-items:center;justify-content:center;width:80px;height:20px;"
};